// src/themes/darkTheme.js
import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    background: {
      default: '#121212',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Without this, browsers keep rendering native scrollbars with a light
        // track/thumb even though the page background is dark — this tells
        // the browser which palette to use for scrollbars, form controls, etc.
        ':root': { colorScheme: 'dark' },
        body: {
          scrollbarColor: '#4a5058 #161b22',
          '&::-webkit-scrollbar': { width: 10, height: 10 },
          '&::-webkit-scrollbar-track': { background: '#161b22' },
          '&::-webkit-scrollbar-thumb': {
            background: '#4a5058',
            borderRadius: 8,
            border: '2px solid #161b22',
          },
          '&::-webkit-scrollbar-thumb:hover': { background: '#5c636b' },
        },
      },
    },
  },
});

export default darkTheme;
